import React, { useContext, useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TablePagination,
  Typography,
} from '@material-ui/core';
import { I18nContext } from 'translations';
import { format } from 'date-fns';
import styles from 'components/Tables/style';
import EmptyData from 'components/Tables/EmptyData';

const BulkEditHistoryTable = ({ classes, data, getHistory, recordsPerPage }) => {
  const { translate } = useContext(I18nContext);
  const [currentPage, setCurrentPage] = useState(data.page);

  useEffect(() => {
    setCurrentPage(data.page);
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
    getHistory(newPage);
  };

  const formatDate = (dateStr) => {
    try {
      return format(new Date(dateStr), 'dd/MM/yyyy hh:mm a');
    } catch {
      return dateStr;
    }
  };

  if (!data || data.data.length === 0) {
    return <EmptyData message={translate('thereIsNoData')} />;
  }

  return (
    <>
      <TableContainer>
        <Table className={classes.table} size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{translate('date')}</TableCell>
              <TableCell>{translate('app.settings.users.bulkEditHistory.executedBy')}</TableCell>
              <TableCell>{translate('app.settings.users.bulkEditHistory.passenger')}</TableCell>
              <TableCell>{translate('app.settings.users.bulkEditHistory.changes')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.data.map((item) => (
              <TableRow hover key={item.id} className={classes.smallData}>
                <TableCell style={{ whiteSpace: 'nowrap' }}>
                  {formatDate(item.executed_at)}
                </TableCell>
                <TableCell>
                  <Typography style={{ fontSize: '0.85em' }}>{item.executed_by?.name}</Typography>
                  <Typography style={{ fontSize: '0.75em' }} className="text-grey">
                    {item.executed_by?.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography style={{ fontSize: '0.85em' }}>{item.passenger?.name}</Typography>
                  <Typography style={{ fontSize: '0.75em' }} className="text-grey">
                    {item.passenger?.email}
                  </Typography>
                  <Typography style={{ fontSize: '0.75em' }} className="text-grey">
                    {item.passenger?.phone}
                  </Typography>
                </TableCell>
                <TableCell style={{ maxWidth: 280 }}>
                  <Typography style={{ fontSize: '0.85em' }}>{item.changes}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={data.total}
        page={currentPage - 1}
        rowsPerPageOptions={[]}
        rowsPerPage={recordsPerPage}
        onChangePage={(event, newPage) => handleChangePage(event, newPage + 1)}
      />
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.data === nextProps.data;
}

export default withStyles(styles)(React.memo(BulkEditHistoryTable, areEqual));
